<gridster [options]="options">
  <gridster-item [item]="widget.layout" *ngFor="let widget of widgets">
      <dashboard-widget [widget]='widget'></dashboard-widget>
  </gridster-item>
</gridster>
